function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M14.022 9.828a.266.266 0 01-.264-.303 5.3 5.3 0 00-.012-1.595 5.278 5.278 0 00-2.128-3.465 5.275 5.275 0 00-3.954-.946.266.266 0 01-.083-.525 5.81 5.81 0 014.35 1.041 5.805 5.805 0 012.34 3.812c.092.583.097 1.173.014 1.753a.266.266 0 01-.263.228zM8.077 14.854h-.019a.266.266 0 01-.246-.285l.038-.53a.27.27 0 01.284-.246c.147.011.257.138.246.284l-.038.53a.266.266 0 01-.265.247zM6.695 14.587a.266.266 0 01-.253-.348l.165-.505a.265.265 0 11.505.165l-.164.505a.266.266 0 01-.253.183zM5.419 13.99a.266.266 0 01-.225-.406l.28-.451a.266.266 0 01.451.28l-.28.452a.266.266 0 01-.226.125zM4.32 13.111a.266.266 0 01-.185-.456l.38-.37a.266.266 0 01.371.38l-.38.37a.266.266 0 01-.186.076zM3.467 11.991a.266.266 0 01-.135-.494l.458-.27a.266.266 0 01.27.458l-.458.27a.267.267 0 01-.135.036zM2.901 10.702a.266.266 0 01-.075-.52l.509-.152a.266.266 0 01.152.509l-.51.152a.27.27 0 01-.076.01zM2.67 9.313a.266.266 0 01-.013-.53l.53-.026a.265.265 0 11.026.53l-.53.026H2.67z",
  fill: "#8D6C9F"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M3.871 5.847s-.85.053-1.594 1.328a2.276 2.276 0 002.125 1.328c1.62 0 2.922-1.328 2.922-1.328l-1.86-1.328H3.872z",
  fill: "#72CAAF"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M1.152 6.301a3.696 3.696 0 012.235-4.76c1.92-.706 4.046.29 4.752 2.21.053.15-.012.286-.162.339-.15.053-.286-.012-.34-.162-.633-1.636-2.479-2.477-4.114-1.844-1.636.634-2.477 2.48-1.844 4.115a3.198 3.198 0 004.04 1.87c.802-.283 1.489-.891 1.836-1.662.099-.119.258-.147.377-.048.077.057.121.182.098.275a3.728 3.728 0 01-4.942 1.8 3.762 3.762 0 01-1.936-2.133z",
  fill: "#8D6C9F"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M7.819 5.638a.238.238 0 01-.02-.134c.03-.236.06-.471.039-.69-.02-.134.096-.287.239-.28.134-.02.287.095.28.238l.01.025c.013.277.001.563-.045.833-.014.118-.147.22-.299.19a.28.28 0 01-.204-.182zM2.118 7.627a.266.266 0 01-.265-.266c0-.027 0-.053.026-.106a2.676 2.676 0 012.497-1.7h.61c1.09 0 2.1.664 2.498 1.7.053.133-.027.292-.16.345-.132.053-.292-.027-.345-.16A2.184 2.184 0 004.96 6.113h-.61c-.877 0-1.674.532-2.02 1.355-.026.106-.106.16-.212.16z",
  fill: "#8D6C9F"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M4.668 3.11c.744 0 1.328.611 1.328 1.328v.665c0 .743-.61 1.328-1.328 1.328-.744 0-1.328-.611-1.328-1.328v-.665c0-.717.584-1.328 1.328-1.328z",
  fill: "#FAEFDE"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M4.668 6.723c-.903 0-1.594-1.01-1.594-1.86v-.425c0-.876.717-1.593 1.594-1.593.877 0 1.594.717 1.594 1.593v.399c0 .876-.69 1.886-1.594 1.886zm0-3.347c-.584 0-1.063.478-1.063 1.062v.399c0 .61.505 1.328 1.063 1.328.584 0 1.062-.744 1.062-1.328v-.399c0-.584-.478-1.062-1.062-1.062z",
  fill: "#8D6C9F"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M11.309 13.284s-.85.053-1.594 1.328a2.276 2.276 0 002.125 1.328c1.62 0 2.922-1.328 2.922-1.328l-1.86-1.328H11.31z",
  fill: "#F283A5"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M15.578 11.197a3.696 3.696 0 01-2.182 4.785c-1.912.727-4.049-.245-4.776-2.157-.055-.15.009-.286.158-.34.15-.055.286.008.341.158.652 1.628 2.508 2.449 4.136 1.797 1.628-.652 2.449-2.508 1.797-4.136A3.198 3.198 0 0010.99 9.48c-.798.292-1.478.908-1.817 1.682-.098.12-.256.15-.377.053a.288.288 0 01-.1-.274 3.727 3.727 0 014.921-1.856 3.764 3.764 0 011.96 2.111z",
  fill: "#8D6C9F"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M8.919 11.934a.24.24 0 01.02.134c-.027.236-.053.472-.03.69.02.134-.093.288-.236.284-.134.02-.288-.092-.284-.236l-.01-.025a3.925 3.925 0 01.036-.833c.013-.118.144-.222.297-.193a.28.28 0 01.207.179zM9.556 15.064a.266.266 0 01-.266-.266c0-.026 0-.053.027-.106a2.676 2.676 0 012.496-1.7h.611c1.09 0 2.099.664 2.497 1.7.053.133-.026.292-.16.345-.132.054-.291-.026-.344-.159a2.184 2.184 0 00-2.02-1.328h-.61c-.877 0-1.674.531-2.019 1.355-.026.106-.106.16-.212.16z",
  fill: "#8D6C9F"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M12.105 10.548c.744 0 1.329.61 1.329 1.328v.664c0 .744-.611 1.328-1.329 1.328a1.332 1.332 0 01-1.328-1.328v-.664c0-.717.585-1.328 1.329-1.328z",
  fill: "#FAEFDE"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M12.105 14.16c-.903 0-1.593-1.009-1.593-1.859v-.425c0-.877.717-1.594 1.593-1.594.877 0 1.594.717 1.594 1.594v.398c0 .877-.69 1.886-1.594 1.886zm0-3.347c-.584 0-1.062.479-1.062 1.063v.398c0 .611.505 1.329 1.063 1.329.584 0 1.062-.744 1.062-1.329v-.398c0-.584-.478-1.063-1.063-1.063z",
  fill: "#8D6C9F"
});

function SvgChild(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
}

export default SvgChild;